import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

/* Estimated size of the expediente emailed with the acta, and the limit */
export default affectedId =>
  errorHandler(
    Vue.$http.get(`purchase/quantification/certificate/email_size/${affectedId}/`)
  ).then(({ data }) => ({ size: data.size, maxSize: data.max_size }))



// WEBPACK FOOTER //
// ./src/services/purchase/fetchDeliveryReceiptEmailSize.js